import React, { Component } from 'react'
import PropTypes from 'prop-types'

import AvailabilityStore from '../stores/AvailabilityStore.js'
import AvailabilityActions from '../actions/AvailabilityActions.js'

import { translate } from 'react-i18next';
import ProductLong from './ProductLong.jsx';

class Equalizer extends Component {
  constructor() {
    super()
    this.handleResize          = debounce(this.handleResize.bind(this), 50)
    this.updateChildrenHeights = this.updateChildrenHeights.bind(this)
  }

  componentDidMount() {
    this.handleResize()
    addEventListener('resize', this.handleResize)
  }

  componentWillUnmount() {
    this.rootNode = null
    this.handleResize.clear()
    removeEventListener('resize', this.handleResize)
  }

  componentDidUpdate() {
    this.handleResize()
  }

  handleResize() {
    setTimeout(this.updateChildrenHeights, 0)
  }

  static getHeights(nodes, byRow = true) {
    let lastElTopOffset = 0,
        groups          = [],
        row             = 0

    groups[row] = []

    for(let i = 0; i < nodes.length; i++){
      let node = nodes[i]
      if (node.firstElementChild && node.firstElementChild.lastElementChild && node.firstElementChild.lastElementChild.firstElementChild && node.firstElementChild.lastElementChild.firstElementChild.nextElementSibling) {
        node = node.firstElementChild.lastElementChild.firstElementChild.nextElementSibling; // Traverse to the element in the product card that we need to resize.
      }

      node.style.height    = 'auto'
      node.style.maxHeight = ''
      node.style.minHeight = ''

      // http://ejohn.org/blog/getboundingclientrect-is-awesome/
      const {top: elOffsetTop, height: elHeight} = node.getBoundingClientRect()

      if(i === 0) {
        lastElTopOffset = elOffsetTop
      }

      if (elOffsetTop != lastElTopOffset && byRow) {
        row++
        groups[row] = []
        lastElTopOffset = elOffsetTop
      }

      groups[row].push([node, elHeight])
    }

    for (let j = 0; j < groups.length; j++) {
      const heights = groups[j].map((item) => item[1])
      const max     = Math.max.apply(null, heights)
      groups[j].push(max)
    }

    return groups
  }

  updateChildrenHeights() {
    const { property, byRow, enabled, nodeWillCompute, nodeWillUpdate } = this.props
    const node = this.rootNode

    if (!node || !enabled(this, node)) {
      return
    }

    if (node !== undefined) {
      const children          = this.props.nodes(this, node)
      const childrenToCompute = Array.from(children).filter(nodeWillCompute)
      const heights           = this.constructor.getHeights(childrenToCompute, byRow)

      for (let row = 0; row < heights.length; row++) {
        const max = heights[row][heights[row].length-1]

        for (let i = 0; i < (heights[row].length - 1); i++) {
          if (nodeWillUpdate(heights[row][i][0], heights[row][i][1])) {
            heights[row][i][0].style[property] = max + 'px'
          }
        }
      }
    }
  }

  render() {
    const {children, property, byRow, enabled, nodes, ...otherProps} = this.props
    return (
      <div ref={node => this.rootNode = node} onLoad={this.handleResize} {...otherProps}>
        {children}
      </div>
    )
  }
}

Equalizer.defaultProps = {
  property:        'height',
  byRow:           true,
  enabled:         () => true,
  nodeWillCompute: () => true,
  nodeWillUpdate:  () => true,
  nodes:           (component, node) => node.children
}

Equalizer.propTypes = {
  children: PropTypes.node.isRequired,
  property: PropTypes.string,
  byRow:    PropTypes.bool,
  enabled:  PropTypes.func,
  nodes:    PropTypes.func
}

// from: https://github.com/component/debounce
function debounce(func, wait, immediate){
  var timeout, args, context, timestamp, result
  if (null == wait) wait = 100

  function later() {
    var last = Date.now() - timestamp

    if (last < wait && last >= 0) {
      timeout = setTimeout(later, wait - last)
    } else {
      timeout = null
      if (!immediate) {
        result = func.apply(context, args)
        context = args = null
      }
    }
  }

  var debounced = function(){
    context = this
    args = arguments
    timestamp = Date.now()
    var callNow = immediate && !timeout
    if (!timeout) timeout = setTimeout(later, wait)
    if (callNow) {
      result = func.apply(context, args)
      context = args = null
    }

    return result
  }

  debounced.clear = function() {
    if (timeout) {
      clearTimeout(timeout)
      timeout = null
    }
  }

  return debounced
}


var ProductsGroupLong = React.createClass({

  getInitialState() {
    return {store: AvailabilityStore.getState()};
  },

  componentDidMount() {
    AvailabilityStore.listen(this.onChange);
  },

  componentWillUnmount() {
    AvailabilityStore.unlisten(this.onChange);
  },

  onChange(state) {
    this.setState({store: state});
  },

  getNodes(equalizerComponent, equalizerElement) {
    return [
      this.refs.node1,
      this.refs.node2,
      this.refs.node3
    ]
  },

    render() {
        var store = this.state.store;
        const { t, title, products, show_voice_only, is_preorder_available, otherProducts } = this.props;

        var productsCount = products.length;

        var productscols = 'col-lg-8 col-lg-offset-2 col-md-10 col-md-offset-1';
        var cardcolclasses = "col-sm-6 col-centered";

        if(productsCount == 6 || productsCount == 3) {
            productscols = "col-sm-12";
            cardcolclasses = "col-md-4 col-md-centered";
        } else if(productsCount == 8) {
            productscols = "col-sm-12";
            cardcolclasses = "col-md-3 col-md-centered";
        }

        let has_ipbb = products.filter(function(p) {
           return p.product_key.indexOf('ipbb') !== -1;
        }).length;

        let show_ipbb_warning = false; // has_ipbb && !is_preorder_available; Force to false to remove message. Preserving old code incase this gets reenstated.

        let smb = store.getIn(['input_address', 'serviceType']) == 'small_business';
        let smb_preorder = (smb && is_preorder_available ? true : false);

        const ipbb_warning = (
            <div className={"col-12"}>
                <div style={{backgroundColor: '#27AAE1', padding: '20px 40px', margin: '0px 10px', color: '#fff'}}>
                <p>
                {t('ipbb_warning')}
                </p>
                </div>
            </div>
        );

        return (
    <div>
      {( productsCount > 0 ? (
      <div className={"col-12"}>
        <div className={"row"}>
        {(smb_preorder ? <p className="preorder_block__title">Begin your service request by choosing from the options below:</p> : '')}
            {(otherProducts ? <h2>{t('common:need_now')}</h2> : false)}
            {(show_ipbb_warning ? ipbb_warning : false)}
            <div className={productscols+" row row-centered"}>
              <Equalizer node={() => getNodes()}>
                {products.map(function(product, index){
                    return <ProductLong refs={n => this.node1 = n}
                        key={index}
                        product={product}
                        cardcolclasses={cardcolclasses}
                        productsCount={productsCount}
                        show_voice_only={show_voice_only}
                        is_preorder_available={is_preorder_available}
                    />;
                })}
              </Equalizer>
            </div>

        </div>
    </div>) :
    <div>

      <div className="snc-section--speedtest">
        <div className="container">
          <div className="snc-tli-speed">
            <div className="snc-tli-speed__intro">
              <h2>How fast is your current speed?</h2>
              <p>Run a quick test of your Internet connection with the Sonic Speed Test. Click the “GO” button to start and after a few seconds, your test will finish and show your internet speed with your current provider.</p>
              <p>The national average is 98.38 Mbps. What’s yours?</p>
              <p>Now, compare that to Sonic’s 1,000 Mbps!</p>
              <div>
                <a href="#" className="snc-btn">Request Fiber Now</a>
              </div>
            </div>
            <div className="snc-tli-speed__speedtest">
              <div className="snc-speedtest">
                <noscript>
                  <div className="snc-speedtest__warning">
                    <h3>JavaScript Required</h3>
                    <p>In order to run the speed test, JavaScript must be enabled. Please allow scripts to run and reload the page.</p>
                  </div>
                </noscript>
                <iframe src="https://sonic.speedtestcustom.com" width="100%" height="650px" frameborder="0"></iframe>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
   )}
  </div>
        );
    }
});

export default  translate('common', { wait: true })(ProductsGroupLong);
